<script>
    export let icon = '';
    export let value = null;
    export let pulse = false;
    export let danger = false;
</script>

<style lang="less">
    @import "./common.less";
    div {
        font-family: oswald;
        position: relative;
        height: 100%;
        flex-direction: column;
    }
    div[data-danger="true"] {
        animation: insetRedPulse 1.8s infinite linear;
    }
    @keyframes insetRedPulse {
        0% {
            box-shadow: inset 0 0 20px rgba(255, 0, 0, 0.7);
        } 50% {
            box-shadow: inset 0 0 20px rgba(255, 0, 0, 0.0);
        } 100% {
            box-shadow: inset 0 0 20px rgba(255, 0, 0, 0.7);
        }
    }
    div[data-pulse="true"] {
        animation: insetGlowPulse 1.8s infinite linear;
    }
    @keyframes insetGlowPulse {
        0% {
            box-shadow: inset 0 0 25px rgba(255, 255, 255, 0.7);
        } 50% {
            box-shadow: inset 0 0 25px rgba(255, 255, 255, 0.0);
        } 100% {
            box-shadow: inset 0 0 25px rgba(255, 255, 255, 0.7);
        }
    }
    .desktop({
        div[data-icon="health"] > span, div[data-icon="health"] > span::after {
            background-color: @healthBarColor;
        }
        div[data-icon="impact"] > span, div[data-icon="impact"] > span::after {
            background-color: @impactBarColor;
        }
        span {
            display: block;
            position: absolute;
            bottom: 0;
            width: 1.7em;
            left: 50%;
            transform: translateX(-50%);
            transition: height .9s 1.9s cubic-bezier(0.37, 0, 0.63, 1);
        };
        span::after {
            display: block;
            content: '';
            position: absolute;
            top: 0;
            width: 100%;
            height: 7.9623vh;
        }
        span, span::after {
            border-radius: 1.4em;
        }
        div {
            display: flex;
            flex-direction: column;
            padding-right: 2px;
        }
        div::after {
            display: block;
            content: '';
            position: absolute;
            top: 0;
            right: 0;
            width: 2px;
            height: 100%;
            background: linear-gradient(0deg, rgba(0,0,0,0) 0%, @brightFg 50%, rgba(0,0,0,0) 100%);
        }
        div[data-icon="month"]::after {
            left: 0;
            right: auto;
        }
    });
    .mobile({
        div {
            display: flex;
            flex-direction: row;
        }
        span {
            display: none;
        }
    });
</style>

<div data-icon="{icon}" data-value="{value}" data-pulse="{pulse}" data-danger="{danger}">
    {#if value != null}
        <span style="height: {(value + 1) / 13 * 100}vh"></span>
    {/if}
    <slot/>
</div>